import { useState } from 'react';
import ContainerFlex from '~/components/containerFlex';
import PasswordModal from '~/components/passwordModal';
import ToggleSwitch from '~/components/toggleSwitch';
import { useModal } from '~/hooks/useModal';
import { CompanyDataBodyRequest } from '~/services/banknow/types';
import Constants from '~/utils/constants';
import { changeCompanyWhereAccepted } from '../../actions';
import { StatusReasonContent } from './StatusReasonContent';

interface ChangeStatusModalProps {
  form: CompanyDataBodyRequest;
  onStatusChanged: (nextStatus: boolean) => void;
}

export function ShowWhereIsAcceptedToogle({
  form,
  onStatusChanged,
}: ChangeStatusModalProps) {
  const [open, setOpen] = useState(false);
  const { openModal, closeModal } = useModal();
  const [reason, setReason] = useState('');
  const isVisible = !!form.shouldFilterByLocation;
  const nextStatus = !isVisible;

  const openConfirmationModal = () => {
    openModal({
      title: nextStatus ? 'Exibir Onde Aceita' : 'Ocultar Onde Aceita',
      message: `Deseja ${
        nextStatus ? 'exibir' : 'ocultar'
      } o parceiro no Onde Aceita?`,
      negativeLabel: null,
      positiveAction: null,
      children: (
        <StatusReasonContent
          confirmationWord={null}
          placeholder={`Digite o motivo para ${
            nextStatus ? 'exibir' : 'ocultar'
          }`}
          onConfirm={(nextReason) => {
            if (!nextReason) {
              closeModal();
              return;
            }

            setReason(nextReason);
            closeModal();
            setOpen(true);
          }}
        />
      ),
    });
  };

  const onChangeStatus = async () => {
    setOpen(false);

    try {
      const response = await changeCompanyWhereAccepted({
        idParceiro: form.companyData.id,
        ondeAceita: nextStatus,
        motivoOndeAceita: reason,
        idUsuario: localStorage.getItem(Constants.USER_ID),
        cnpj: form?.companyData?.cnpj?.unmasked,
      });

      if (!response.success) {
        throw new Error(
          response.message || response.mensagem || 'Houve um erro',
        );
      }

      onStatusChanged(nextStatus);
      openModal({
        title: 'Sucesso',
        message: `Onde Aceita ${
          nextStatus ? 'ativado' : 'desativado'
        } com sucesso!`,
        widthInPercent: 30,
      });
    } catch (error) {
      openModal({
        title: `Houve um erro ao ${
          nextStatus ? 'exibir' : 'ocultar'
        } onde aceita`,
        message: error?.message ?? 'Houve um erro',
        widthInPercent: 30,
      });
    }
  };

  if (!form?.companyData?.id) return null;
  return (
    <ContainerFlex marginTop={8}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: 12,
          alignItems: 'center',
        }}
      >
        <span style={{ fontSize: 16, fontWeight: 700 }}>
          Exibir Onde Aceita
        </span>
        <ToggleSwitch
          id="switchWhereIsAccepted"
          toggled={isVisible}
          onChangeFunction={openConfirmationModal}
          widthSwitchLabel={45}
          heightSwitchButton={14}
          disabled={false}
        />
      </div>
      <PasswordModal
        onClose={() => setOpen(false)}
        open={open}
        onSuccessValidation={onChangeStatus}
      />
    </ContainerFlex>
  );
}
